/* Restore Suite: open header mega menu on hover (desktop only). 2026-06-20 */
(function () {
  function init() {
    var mq = window.matchMedia('(min-width: 990px)');
    var menus = document.querySelectorAll('.header__inline-menu header-menu');
    if (!menus.length) return;
    menus.forEach(function (hm) {
      var details = hm.querySelector('details');
      if (!details) return;
      var timer;
      hm.addEventListener('mouseenter', function () {
        if (!mq.matches) return;
        clearTimeout(timer);
        menus.forEach(function (other) {
          if (other !== hm) {
            var d = other.querySelector('details');
            if (d) d.open = false;
          }
        });
        details.open = true;
      });
      hm.addEventListener('mouseleave', function () {
        if (!mq.matches) return;
        timer = setTimeout(function () { details.open = false; }, 160);
      });
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
